angular.module("Main").factory("PaymentService", ["$http", "NODEBACKEND", "SessionService", function ($http, NODEBACKEND, SessionService) {
    return {
        startPayment: startPayment,
        confirmPayment: confirmPayment,
        cancelPayment: cancelPayment,
        startPaymentKurs: startPaymentKurs,
        confirmPaymentKurs: confirmPaymentKurs,
        timeoutPayment: timeoutPayment,
        startPaymentBlockkurs: startPaymentBlockkurs,
        getArticlePrice: getArticlePrice,
        saveMVBooking: saveMVBooking,
        startPaymentPayPal: startPaymentPayPal,
        capturePaymentPayPal: capturePaymentPayPal,
        startPayPalBlockkurs: startPayPalBlockkurs,
        startKursPayPal: startKursPayPal
    };

    function startPayment(booking) {
        booking.ClubId = SessionService.getAuthData();
        return $http.post(NODEBACKEND + "/payment/six/start", booking).then(function (response) {
            return response.data;
        })
    }

    function confirmPayment(requestId) {
        return $http.put(NODEBACKEND + "/payment/six/confirm/" + requestId, {}).then(function (response) {
            return response.data;
        })
    }

    function confirmPaymentKurs(requestId) {
        return $http.put(NODEBACKEND + "/payment/six/confirm/kurs/" + requestId, {}).then(function (response) {
            return response.data;
        })
    }

    function cancelPayment(requestId) {
        return $http.put(NODEBACKEND + "/payment/six/cancel/" + requestId, {}).then(function (response) {
            return response.data;
        })
    }

    function startPaymentKurs(booking) {
        booking.clubId = SessionService.getAuthData();
        return $http.post(NODEBACKEND + "/payment/six/start/kurs", booking).then(function (response) {
            return response.data;
        })
    }

    function timeoutPayment(requestId) {
        return $http.get(NODEBACKEND + "/payment/six/timeout/" + requestId, {}).then(function (response) {
            return response.data;
        })
    }

    function startPaymentBlockkurs(booking) {
        booking.clubId = SessionService.getAuthData();
        return $http.post(NODEBACKEND + "/payment/six/start/block", booking).then(function (response) {
            return response.data;
        })
    }

    function getArticlePrice(personNr, appointmentTypeNr, appointmentDate) {
        let articleData = {personNr: personNr, appointmentType: appointmentTypeNr, appointmentDate: appointmentDate};
        return $http.post(NODEBACKEND + "/payment/mv/articles/price", articleData).then(function (response) {
            return response.data;
        })
    }

    function saveMVBooking(orderId, lang) {
        return $http.post(NODEBACKEND + "/payment/mv/booking/" + orderId + "/" + lang).then(function (response) {
            return response.data;
        })
    }

    function startPaymentPayPal(booking) {
        booking.clubId = SessionService.getAuthData();
        return $http.post(NODEBACKEND + "/payment/paypal/start", booking).then(function (response) {
            return response.data;
        })
    }
    
    function capturePaymentPayPal(id) {
        let data = {OrderId: id};
        return $http.post(NODEBACKEND + "/payment/paypal/capture", data).then(function (response) {
            return response.data;
        })
    }

    function startPayPalBlockkurs(booking) {
        booking.clubId = SessionService.getAuthData();
        return $http.post(NODEBACKEND + "/payment/paypal/start/block", booking).then(function (response) {
            return response.data;
        })
    }

    function startKursPayPal(booking) {
        booking.clubId = SessionService.getAuthData();
        return $http.post(NODEBACKEND + "/payment/paypal/start/kurs", booking).then(function (response) {
            return response.data;
        })
    }
}]);